<div class="mt-5 overflow-x-auto rounded-xl border py-5">
  <div class="flex justify-between gap-6" *transloco="let t">
    <div class="min-w-60 flex-1 pl-6">
      <div class="flex items-center gap-1">
        <p class="text-sm font-normal text-grey">
          {{ t('portal.trainings.detailPage.completionRate') }}
        </p>
        <mat-icon
          class="material-icons-outlined hvs-icon-base cursor-help text-grey-midGrey"
          [matTooltip]="t('portal.trainings.detailPage.completionRateTooltip')"
          matTooltipPosition="above"
          matTooltipClass="tooltip-above"
          >help_outline</mat-icon
        >
      </div>
      <div class="mt-3 flex items-center gap-4">
        <!-- Completion Ring -->
        <div
          class="size-7 rounded-full outline outline-[6px] outline-offset-[-3px] outline-grey-midGrey"
        ></div>
        <!-- Percentage -->
        <div
          class="justify-start text-2xl font-semibold leading-8 text-blue-dark"
        >
          {{ completionRate }}%
        </div>
        <!-- Participants Count with Person Icon -->
        <span
          class="flex items-center gap-0 text-sm font-medium leading-5 text-blue-dark"
        >
          <mat-icon class="translate-y-0.5 text-sm text-blue-dark"
            >person</mat-icon
          >
          {{ numberOfCompletedStudents }} / {{ numberOfEnrolledStudents }}
        </span>
      </div>
    </div>
    <div class="min-w-48 flex-1 border-l-2 pl-6">
      <p class="text-sm font-normal text-grey">
        {{
          t(
            started
              ? 'portal.trainings.detailPage.started'
              : 'portal.trainings.detailPage.startOn'
          )
        }}
      </p>
      <div class="mt-3 flex items-center gap-2">
        <p class="text-sm font-medium leading-5 text-blue-dark">
          {{ startAt | date: 'dd.MM.yyyy' }}
        </p>
        @if (status && !isDeadlinePassed) {
          <app-learning-plan-status [status]="status">
          </app-learning-plan-status>
        }
      </div>
    </div>
    <div class="min-w-48 flex-1 border-l-2 pl-6">
      @if (deadline) {
        <p class="text-sm font-normal text-grey">
          {{ t('portal.trainings.detailPage.period.availableUntil') }}
        </p>
        <p class="mt-3 text-sm font-medium leading-5 text-blue-dark">
          {{ deadline | date: 'dd.MM.yyyy' }}
        </p>
      } @else {
        <p class="text-sm font-normal text-grey">
          {{ t('portal.trainings.detailPage.period.label') }}
        </p>
        <p class="mt-3 text-sm font-medium leading-5 text-blue-dark">
          1 {{ durationTranslationKey | transloco }}
        </p>
        <p class="mt-0.5 text-xs text-grey">
          {{ phaseStartDate | date: 'dd.MM.yyyy' }} -
          {{ phaseEndDate | date: 'dd.MM.yyyy' }}
        </p>
      }
    </div>
    @if (!deadline) {
      <div class="min-w-48 flex-1 border-l-2 pl-6">
        <p class="text-sm font-normal text-grey">
          {{ t('portal.trainings.detailPage.repetition.label') }}
        </p>
        <div class="mt-3 flex flex-col gap-0.5">
          <p class="text-sm font-medium leading-5 text-blue-dark">
            {{ repeatingStatusTranslationKey | transloco }}
          </p>
          <p class="text-xs leading-3 text-grey">
            {{ repeatingTypeKey | transloco }}
          </p>
        </div>
      </div>
    }
  </div>
</div>
